import { format } from 'date-fns';
import { BASE_URL } from 'src/components/10-atoms/seo/constants';
import { appendTimeZone } from 'src/utils/date';
import { getQuestionLabel } from '../containers/QuestionList/utils';
import { NodeType } from '../graphql/common/types/node';
import { getEPHomeUrl } from './getEPHomeUrl';
function buildHierarchyItems(ancestorsDetails, knownNodes) {
    const items = [];
    const communityTitle = knownNodes?.community?.data.title ??
        ancestorsDetails?.community?.data.title;
    if (communityTitle) {
        items.push({
            name: communityTitle,
            item: getEPHomeUrl(),
        });
    }
    const examLevel = knownNodes?.examLevel ?? ancestorsDetails?.examLevel;
    const examLevelTitle = knownNodes?.examLevel?.data.title ??
        ancestorsDetails?.examLevel?.data.title;
    if (examLevelTitle) {
        items.push({
            name: examLevelTitle,
            item: getEPHomeUrl(examLevel?.id),
        });
    }
    const subject = knownNodes?.subject ??
        ancestorsDetails?.writtenSubject ??
        ancestorsDetails?.oralsSubject;
    if (subject) {
        items.push({
            name: subject.data.title,
            item: `${BASE_URL}/exam-prep/subject/${subject.id}`,
        });
    }
    const qp = knownNodes?.qp ??
        ancestorsDetails?.writtenQP ??
        ancestorsDetails?.oralsQP;
    if (qp) {
        const datePart = qp.type === NodeType.ORALS_QP
            ? format(new Date(appendTimeZone(qp.data.dateNL)), 'MMM yyyy')
            : undefined;
        const qpName = [datePart, qp.data.label].filter(Boolean).join(' ');
        if (qpName) {
            items.push({
                name: qpName,
                item: `${BASE_URL}/exam-prep/qp/${qp.id}`,
            });
        }
    }
    const question = knownNodes?.question;
    if (question) {
        const questionLabel = getQuestionLabel(question);
        if (questionLabel) {
            items.push({
                name: questionLabel,
                item: `${BASE_URL}/exam-prep/question/${question.id}`,
            });
        }
    }
    return items;
}
export default function getHeirarchyJsonLD(ancestorsDetails, knownNodes) {
    const items = buildHierarchyItems(ancestorsDetails, knownNodes);
    if (items.length === 0) {
        return undefined;
    }
    return {
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.name,
            ...(item.item && { item: item.item }),
        })),
    };
}
